import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {CreazionePraticaStoreService} from '../../services/creazione-pratica-store.service';
import {getComponentFromFormTenantLavoro, getFascicoloLavoro} from '../../config/lavoro-form-configuration';
import {
  getComponentFromFormTenantPareristica,
  getFascicoloPareristica
} from '../../config/pareristica-form-configuration';
import {
  getComponentFromFormTenantAministrativa,
  getFascicoloAmministrativo
} from '../../config/amministrativa-form-configuration';
import {
  getComponentFromFormTenantAutoritaInd,
  getFascicoloAutoritaInd
} from '../../config/autorita-indipendente-form-configuration';
import {getComponentFromFormTenantCivile, getFascicoloCivile} from '../../config/civile-form-configuration';
import {getComponentFromFormTenantPenale, getFascicoloPenale} from '../../config/penale-form-configuration';
import {getComponentFromFormTenantTributario, getFascicoloTriburario} from '../../config/tributario-form-configuration';
import {TipoFascicolo} from '../../../../../common/models/tipologiche/tipo-fascicolo';
import {PropertiesSettings} from '../../../../../core/configuration/properties-settings';
import {InsertionHostDirective} from '../../../../../common/directives/insertion-host.directive';
import {TipoPratica} from '../../../../../common/models/tipologiche/tipo-pratica';
import {OperationsService} from '../../../../../core/services/operations.service';
import {distinctUntilChanged, filter, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { TIPI_PRATICA } from 'src/app/pratica/config/tipi-pratica.enum';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { ActivatedRoute, Router } from '@angular/router';
import { Scadenza } from 'src/app/common/models/scadenza';



@Component({
  selector: 'step-dati-gen-fascicolo',
  templateUrl: './step-dati-gen-fascicolo.component.html',
  styleUrls: ['./step-dati-gen-fascicolo.component.css']
})
export class StepDatiGenFascicoloComponent implements OnInit, OnDestroy {

  @ViewChild(InsertionHostDirective) private form!: InsertionHostDirective;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();
  formComponentDynamic: string;
  tipoPratica: TipoPratica;
  componentRef: ComponentRef<any>;
  tipoFascicolo: TipoFascicolo;
  fascicolo: any;
  idPratica: string;
  urlInsert: string;
  accordions = stepMap;
  editMode = false;
  idFascicoloOrigine: string = null;
  private componentDestroyed$: Subject<void> = new Subject<void>();
  initialDataNotifica: number | null = null; 
  scadenze: Scadenza[] = [];
  sezione = null;

  constructor(
    private operationService: OperationsService,
    private factoryResolver: ComponentFactoryResolver,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private creazionePraticaStore: CreazionePraticaStoreService) {
  }

  ngOnInit() {
    this.fascicolo = this.accordions[0].properties.fascicolo;
    this.creazionePraticaStore.tipoPratica$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(tipo => this.tipoPratica = tipo);
    this.creazionePraticaStore.tipoFascicolo$
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        takeUntil(this.componentDestroyed$)
        )
      .subscribe(tipo => {
        this.tipoFascicolo = tipo;
        if (this.tipoFascicolo) {
        }
        this.getFormTenantByTipo();
      });
    this.creazionePraticaStore.fascicolo$.pipe(takeUntil(this.componentDestroyed$)).subscribe(el => this.fascicolo = el);
    this.activatedRoute.queryParams.subscribe(params => {
      this.idFascicoloOrigine = params['idFascicoloOrigine'];
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.removeDynamicComponent();
    this.creazionePraticaStore.setTipoFascicolo(null);
    this.creazionePraticaStore.setFascicolo(null);
    this.form?.viewContainerRef?.clear();
  }

  private getFormTenantByTipo() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
    let properties = this.accordions[index].properties;
    this.tipoFascicolo = properties.tipoFascicolo;
    this.tipoPratica = properties.tipoPratica;
    this.urlInsert = properties.urlInsert;
    this.idPratica = properties.idPratica;
    this.operationService
      .getFormTenantByTipo(properties.tipoPratica.id, properties.tipoFascicolo.id)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(response => {
        this.formComponentDynamic = response && response.idFormTenant ? response.idFormTenant : '';
        this.removeDynamicComponent();
        this.addDynamicComponent();
    });
  }

  private addDynamicComponent() {
    let view: boolean = !!this.accordions[0].properties.fascicolo.id && !this.editMode;
    const factory = this.factoryResolver.resolveComponentFactory(this.getComponent(this.formComponentDynamic, view));

    const viewContainerRef = this.form.viewContainerRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent(factory);
    this.componentRef.instance.ctxBodyFascicolo = {fascicolo: this.accordions[0].properties.fascicolo};
    // aggancio l'evento di saveForm 
    this.componentRef.instance.saveForm?.subscribe(() => {
      this.creaFascicolo(this.componentRef.instance.request);
    });
    this.createFormField();
  }

  private removeDynamicComponent() {
    this.form?.viewContainerRef?.clear();
  }

  creaFascicolo(request: any) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
    let properties = this.accordions[index].properties;
    this.tipoFascicolo = properties.tipoFascicolo;
    this.tipoPratica = properties.tipoPratica;
    this.urlInsert = properties.urlInsert;
    this.idPratica = properties.idPratica;
    request["idPratica"] = this.idPratica || properties.fascicolo.idParent;
    if (this.idFascicoloOrigine) {
      this.copiaFascicolo(request);
      return
    }
    if(!!this.fascicolo.id) {
      this.update(request);
    } else {
      this.create(request);
    }
  }


  private copiaFascicolo(request: any) {
    this.operationService.copyFascicoloGeneric(
      this.urlInsert + '/copiafascicolo/' + this.idFascicoloOrigine,
      request
    ).subscribe(
      response => {
        let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
        this.accordions[index].complete = true;
        let properties = this.accordions[index].properties;
        this.fascicolo = response.fascicolo;
        this.router.navigate([
          `/inserimento/fascicolo/${properties.tipoPratica.endpoint}/${properties.tipoFascicolo.endpoint}/ins/dati_generali_fascicolo/${response.fascicolo.id}`
        ]);
        this.accordions.forEach(x => {
          x.properties["fascicolo"] = response.fascicolo;
          x.disabled = false;
        });
      }
    );
  }

  private create(request: any) {
    this.operationService.createFascicoloGeneric(this.urlInsert, request).subscribe(response => {
      let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
      this.accordions[index].complete = true;
      let properties = this.accordions[index].properties;
      this.fascicolo = response.fascicolo;
      this.router.navigate([
        `/inserimento/fascicolo/${properties.tipoPratica.endpoint}/${properties.tipoFascicolo.endpoint}/ins/dati_generali_fascicolo/${response.fascicolo.id}`
      ]);
      this.accordions.forEach(x => {
        x.properties["fascicolo"] = response.fascicolo;
        x.disabled = false;
      });
      let url = this.getReadSezioneUrl(this.tipoPratica.endpoint, this.tipoFascicolo.endpoint);
      this.operationService.readSezione(url, response.fascicolo.idSezioneDocumentazioneAllegata).subscribe((res) => {
        res.sezione.esn = "SezioneDocumentazioneAllegata";
        res.sezione.documentazione = res.sezione.documentiAggregati;
        let indexDoc = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
        if (indexDoc !== -1) {
          this.accordions[indexDoc].properties.sezione = res.sezione;
          this.creazionePraticaStore.onSectionLoaded(res.sezione);
        }
      })
    });
  }

  private update(request: any) {
    // request.fascicolo["inUscita"] = request.fascicolo.tipoReg.toLowerCase() === "in uscita";
    // delete request.fascicolo.tipoReg;
    this.operationService.updateFascicoloGeneric(this.urlInsert, request).subscribe(response => {
      let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
      this.accordions[index].complete = true;
      this.fascicolo = response.fascicolo;
      this.creazionePraticaStore.onFascicoloLoad(response.fascicolo);
      this.accordions.forEach(x => {
        x.properties["fascicolo"] = response.fascicolo;
        x.disabled = false;
      });
      this.editMode = false;
      let url = this.getReadSezioneUrl(this.tipoPratica.endpoint, this.tipoFascicolo.endpoint);
      this.operationService.readSezione(url, response.fascicolo.idSezioneDocumentazioneAllegata).subscribe((res) => {
        res.sezione.esn = "SezioneDocumentazioneAllegata";
        res.sezione.documentazione = res.sezione.documentiAggregati;
        let indexDoc = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO);
        this.accordions[indexDoc].properties.sezione = res.sezione;
        this.creazionePraticaStore.onSectionLoaded(res.sezione);
      })
      this.removeDynamicComponent();
      this.addDynamicComponent();
      if (
        this.tipoPratica.endpoint === TIPI_PRATICA.PARERISTICA &&
        this.tipoFascicolo.endpoint === 'parere' &&
        this.fascicolo?.dataNotifica &&
        (this.initialDataNotifica === null || this.fascicolo.dataNotifica !== this.initialDataNotifica)
      ){
        this.initialDataNotifica = this.fascicolo.dataNotifica;
        this.operationService.readFascicolo(this.accordions[index].properties.urlInsert, this.accordions[index].properties.fascicolo.id).subscribe(
          res => {
            this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
            this.updateSezioneAdempimenti(res.idSezioneScadenze);
          }
        );
        return;
      }
    });
  }

  updateSezioneAdempimenti(idSezioneScadenze:string) {
    let indexAdempimenti = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    let tipoPratica = this.accordions[indexAdempimenti].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[indexAdempimenti].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[indexAdempimenti].properties.fascicolo.idSezioneScadenze || idSezioneScadenze;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/scadenze`;
    if(!idSezione) return;
    this.operationService.readSezione(url, idSezione).subscribe(response => {
      this.fascicolo = this.accordions[indexAdempimenti].properties.fascicolo;
      this.accordions[indexAdempimenti].properties.sezione = response.sezione;
      this.accordions[indexAdempimenti].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO;
      this.creazionePraticaStore.onSectionLoaded(response.sezione);
      this.creazionePraticaStore.setAdempimenti(response.sezione.scadenze);
      this.creazionePraticaStore.save();
      this.scadenze = response.sezione.scadenze;
      this.sezione = response.sezione;
      this.accordions[indexAdempimenti].complete = true;
    });
  }


  private getReadSezioneUrl(tipoPratica: any, tipoFascicolo: any) {
    return `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/documentazione`;
  }

  private createFormField() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
    let properties = this.accordions[index].properties;
    if(!!properties.fascicolo.id) this.accordions[index].complete = true;
    const fascicolo = {...this.getFascicolo(), ...properties.fascicolo};
    fascicolo.tipoFascicolo = this.tipoFascicolo;
    this.creazionePraticaStore.setFascicolo(fascicolo);
    this.componentRef.instance.fascicolo = fascicolo;
    this.componentRef.instance.request = { fascicolo };
    this.componentRef.instance.nomeFascicolo = this.tipoFascicolo.label;
    this.componentRef.instance.labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;
    this.componentRef.instance.inserimento = true;
    this.componentRef.instance.wizard = false;
    this.componentRef.instance.minervaWizard = false;
    if (!!this.componentRef.instance.createForm) {
      this.componentRef.instance.createForm
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(() => {
          /*this.componentRef.instance.datiGeneraliForm.valueChanges.pipe(distinctUntilChanged()).subscribe(() =>
            this.creazionePraticaStore.updateFascicolo(fascicolo);}
          );*/
          this.componentRef.instance.datiGeneraliForm.statusChanges.pipe(distinctUntilChanged()).subscribe(status => {
            this.creazionePraticaStore.updateValidityFascicolo(status === 'VALID')
          })
        });
    }

    this.creazionePraticaStore.saveExitFascicoloEvent$.pipe(
      takeUntil(this.componentDestroyed$),
      filter(el => el === true),
      tap(() => this.creazionePraticaStore.updateFascicolo(fascicolo))
    ).subscribe();

    if (!!this.componentRef.instance.saveForm) {
      this.componentRef.instance.saveForm
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(() => {
          this.creazionePraticaStore.updateFascicolo(fascicolo);
          this.changeStep.emit();
        });
    }
    if (!!this.componentRef.instance.resetForm) {
      this.componentRef.instance.resetForm
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(() => {
          this.creazionePraticaStore.setTipoFascicolo(null);
          this.creazionePraticaStore.setFascicolo(null);
          this.creazionePraticaStore.setTipoFascicolo(this.tipoFascicolo);
          this.creazionePraticaStore.setFascicolo(this.fascicolo);
        });
    }
  }

  private getComponent(idForm, view = false): any {
    let fascicoloId = this.accordions[0].properties.fascicolo.id;
    switch (this.tipoPratica.endpoint) {
      case TIPI_PRATICA.AMMINISTRATIVA : {
        return getComponentFromFormTenantAministrativa(idForm, view);
      }
      case TIPI_PRATICA.AUTORITA_IND_REG : {
        return getComponentFromFormTenantAutoritaInd(idForm, view);
      }
      case TIPI_PRATICA.CIVILE : {
        return getComponentFromFormTenantCivile(idForm, view);
      }
      case TIPI_PRATICA.LAVORO: {
        return getComponentFromFormTenantLavoro(idForm, view);
      }
      case TIPI_PRATICA.PARERISTICA: {
        return getComponentFromFormTenantPareristica(idForm, view);
      }
      case TIPI_PRATICA.PENALE: {
        return getComponentFromFormTenantPenale(idForm, view);
      }
      case TIPI_PRATICA.TRIBUTARIO : {
        return getComponentFromFormTenantTributario(idForm, view);
      }
    }
  }

  private getFascicolo(): any {
    if (this.fascicolo) {
      return this.fascicolo;
    }
    switch (this.tipoPratica.endpoint) {
      case TIPI_PRATICA.AMMINISTRATIVA : {
        return getFascicoloAmministrativo(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.AUTORITA_IND_REG : {
        return getFascicoloAutoritaInd(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.CIVILE : {
        return getFascicoloCivile(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.LAVORO: {
        return getFascicoloLavoro(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.PARERISTICA: {
        return getFascicoloPareristica(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.PENALE: {
        return getFascicoloPenale(this.tipoFascicolo.endpoint);
      }
      case TIPI_PRATICA.TRIBUTARIO : {
        return getFascicoloTriburario(this.tipoFascicolo.endpoint);
      }
    }
  }

  setTipoFascicolo(tipoFascicolo: TipoFascicolo) {
    this.creazionePraticaStore.setTipoFascicolo(tipoFascicolo);
    //la chiamata a this.getFormTenantByTipo() non è necessaria in quanto, dopo
    //aver settato il tipo fascicolo nello store, lo stesso metodo viene chiamato in ngOnInit()
    //nella subscribe
    // this.getFormTenantByTipo();

  }

  edit(val: boolean) {
    this.editMode = val;
    this.creazionePraticaStore.fascicolo$
    .pipe(takeUntil(this.componentDestroyed$))
    .subscribe(el => {
      if (el) {
        // Memorizza il valore iniziale di dataNotifica se non è stato ancora assegnato
        if (this.initialDataNotifica === undefined) {
          this.initialDataNotifica = JSON.parse(JSON.stringify(el.dataNotifica));
        }
        this.fascicolo = el;
      }
    });
    this.removeDynamicComponent();
    this.addDynamicComponent();
  }


}
